import { useState, useEffect } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import styles from "../../screens2/Requirement/Requirement.module.css";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import { useDispatch } from "react-redux";

const CandidateMapCard = ({
  candidate,
  updateSelectedCandidates,
  isSelected,
  selectedCandidate,
  selectedCandidates,
  MAX_CANDIDATES,
  setSelectedCandidates,
}) => {
  const dispatch = useDispatch();
  const [rate, setRate] = useState(
    selectedCandidate?.rate || candidate?.rate || ""
  );
  const [selectedFileName, setSelectedFileName] = useState("");

  const [resume, setResume] = useState(
    selectedCandidate?.resume || candidate?.resume
  );
  const [isChecked, setIsChecked] = useState(
    candidate?.is_job_applied || isSelected
  );
  const [israteEdit, setIsRateEdit] = useState(false);

  useEffect(() => {
    if (isChecked) {
      updateSelectedCandidates({ id: candidate.id, rate, resume });
    }
  }, [rate, resume, isChecked]);

  const handleRateChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,5}$/.test(value)) {
      setRate(value);
    }
  };

  const handleAttachResume = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setResume(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // const handleCheckboxChange = (event) => {
  //   console.log({ selectedCandidates });
  //   console.log({ MAX_CANDIDATES });
  //   console.log(event.target.checked);
  //   if (selectedCandidates.length < MAX_CANDIDATES) {
  //   // if (selectedCandidates.length !== MAX_CANDIDATES) {
  //     const checked = event.target.checked;
  //     setIsChecked(checked);

  //     if (!checked) {
  //       // Clear candidate data when unchecked
  //       updateSelectedCandidates({
  //         id: candidate.id,
  //         rate: null,
  //         resume: null,
  //       });
  //     }
  //   } else {
  //     alert(`You can only apply up to 5 candidates.`);
  //   }
  // };

  // const handleCheckboxChange = (event) => {
  //   const checked = event.target.checked;

  //   if (checked) {
  //     if (selectedCandidates.length < MAX_CANDIDATES) {
  //       setIsChecked(true);
  //     } else {
  //       alert(`You can only apply up to ${MAX_CANDIDATES} candidates.`);
  //     }
  //   } else {
  //     setIsChecked(false);
  //     // Clear candidate data when unchecked
  //     updateSelectedCandidates({
  //       id: candidate.id,
  //       rate: null,
  //       resume: null,
  //     });
  //   }
  // };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;

    if (checked) {
      // Exclude already applied candidates and count only newly selected ones
      const newlySelectedCandidates = selectedCandidates.filter(
        (item) => !item.is_job_applied
      );

      console.log("Newly Selected Candidates:", newlySelectedCandidates.length);
      console.log("MAX_CANDIDATES:", MAX_CANDIDATES);

      if (newlySelectedCandidates.length < MAX_CANDIDATES) {
        setIsChecked(true);
        updateSelectedCandidates({
          id: candidate.id,
          rate,
          resume,
          is_job_applied: false,
        });
      } else {
        alert(`You can only apply up to ${MAX_CANDIDATES} candidates.`);
      }
    } else {
      setIsChecked(false);
      // Remove the candidate from the selectedCandidates when unchecked
      setSelectedCandidates((prev) =>
        prev.filter((item) => item.id !== candidate.id)
      );
    }
  };

  return (
    <Box
      className={styles.candidateListOnApply}
      sx={candidate?.is_job_applied ? { pointerEvents: "none" } : {}}
    >
      <Box className={styles.box1}>
        <Typography>{candidate?.full_name}</Typography>
        <Typography>{candidate?.current_job_title}</Typography>
        <Typography>
          Rate -{" "}
          {israteEdit ? (
            <input
              type="text"
              value={rate}
              onChange={handleRateChange}
              onBlur={() => setIsRateEdit(false)}
              style={{ width: "60px" }}
            />
          ) : (
            rate
          )}{" "}
          Hourly{" "}
          <span onClick={() => setIsRateEdit(!israteEdit)}>Edit Rate</span>
        </Typography>
      </Box>
      <Box className={styles.box2}>
        <Typography>
          <label
            style={{ cursor: "pointer", color: "#1b89de", marginBottom: "0" }}
          >
            {candidate?.is_job_applied
              ? "Candidate Allready Applied"
              : resume
              ? "Change Resume"
              : "Attach Resume"}
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleAttachResume}
            />
          </label>
          <br />
          {selectedFileName}
        </Typography>
        <Checkbox
          checked={isChecked}
          disabled={candidate?.is_job_applied}
          onChange={handleCheckboxChange}
        />
      </Box>
    </Box>
  );
};

export default CandidateMapCard;
